import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import ExportData from 'highcharts/modules/export-data';
import Accessibility from 'highcharts/modules/accessibility';
import HighchartsReact from 'highcharts-react-official';
import RegionHeader from './RegionHeader';
import ISLTable from './ISLTable';
import { getDefaultDate } from './routines';

Exporting(Highcharts)
ExportData(Highcharts)
Accessibility(Highcharts)

const TimeSeriesGrf = (props) => { 
    const { date, handleButtonClick } = props;
    const monyr = date ? date : getDefaultDate();
    const buttonValue = "timeseriestable";
    const indices = {
      "precip": { name: "Precipitation" },
      "eddi": { name: "ET" },
      "gw": { name: "Groundwater" },
      "sf": { name: "Streamflow" },
    };

    const dataFileName = (window.location.hostname === "localhost" ? "." : "/ma") + "/data/regional_timeseries_"+monyr+".json";

    const default_options = {
      chart: {
        zoomType: "x",
        height: Math.min((window.innerHeight * 0.75), 200),
      },
      colors: [
				'green',
				'#FA5F55',
				'goldenrod',
				'cornflowerblue',
			],
      plotOptions: {
        line: {
            cursor: "pointer",
            lineWidth: 2,
            states: {
                hover: {
                  enabled: false
                },
                inactive: {
                  enabled: false
                }
            },
        },
        series: {
          pointPlacement: "on",
          connectNulls: false,
        }
      },
      xAxis: {
        type: "datetime",
        dateTimeLabelFormats: {
            day: "%b %Y",
            week: "%b %Y",
            month: "%b %Y",
            year: "%b %Y",
        },
        gridLineWidth: 1,
      },
      yAxis: {
        title: {
            text: "Percentile"
        },
        min: 0,
        max: 100,
        tickInterval: 10,
        labels: {
          step: 2
        },
        plotBands: [{
          color: "rgb(139, 0, 0)",
          from: 0,
          to: 2
        },{
          color: "rgb(255, 103, 0)",
          from: 2,
          to: 10
        },{
          color: "rgb(255, 192, 0)",
          from: 10,
          to: 20
        },{
          color:"rgb(255, 255, 153)",
          from: 20,
          to: 30
        }],
      },
      legend: {
        align: 'right',
        padding: 0,
        margin: 6,
        itemStyle: {
          fontWeight: 'normal'
        },
      }, 
      exporting: {
        enabled: false,
/*      menuItemDefinitions: {
          // Custom definition
          downloadCSV: {
            text: 'Download data as CSV'
          },
        },
        buttons: {
          contextButton: {
            menuItems: [
               "downloadPNG",
               "downloadCSV",
             ]
          }
        }*/
      },
      credits: {
        enabled: false
      },
      tooltip: {
        shared: true,
        // following to allow ET to be spelled out
        pointFormat: '<span style="color:{point.color}">●</span> {series.options.tooltipName}: <b>{point.y}</b><br/>',
        dateTimeLabelFormats: {
            month: "%b %Y",
            day: "%A, %b %Y",
            hour: "%b %Y",
            minute: "%b %Y",
            second: "%b %Y",
            millisecond: "%b %Y",
        },
      },
      title: {
        text: "",
      },
      subtitle: {
        text: null,    //added in fill_graph
      },
      series: null,    //added in fill_graph
    };

    const [ options1, setOptions1 ] = useState(default_options);
    const [ options2, setOptions2 ] = useState(default_options);
    const [ options3, setOptions3 ] = useState(default_options);
    const [ options4, setOptions4 ] = useState(default_options);
    const [ options5, setOptions5 ] = useState(default_options);
    const [ options6, setOptions6 ] = useState(default_options);
    const [ options7, setOptions7 ] = useState(default_options);

    function fill_graph(results) {
      var resVal, dateVal, data_series,
          all_data_series = {};
      // for each region
      for (const region of Object.keys(results)) {
        const regionData = results[region]
        all_data_series[region] = []
        // for each index
        for (const index of Object.keys(indices)) {
          data_series = [];
          // for each month
          for (const [yyyymm, res] of Object.entries(regionData[index])) {
            const [yr, mn] = yyyymm.split('-')
            dateVal = new Date(yr, mn-1, 1);
            if (res !== "") {
              resVal = parseFloat(res);
              data_series.push([dateVal.getTime(), resVal]);
            } else {
              data_series.push([dateVal.getTime(), null]);
            }
          };
          if (data_series.length > 0) {
            all_data_series[region].push({
              name: indices[index].name,
              tooltipName: index !== "eddi" ? indices[index].name : "Evapotranspiration",
              data: data_series,
              type: "line",
              tooltip: {
                valueSuffix: " percentile"
              }
            });
          }
        }
      };
      // trigger drawing of graph
		  setOptions1({...default_options, series: all_data_series["Western"], subtitle: {text: "Western Region"}});
      setOptions2({...default_options, series: all_data_series["Connecticut River"], subtitle: {text: "CTRV"}});
	    setOptions3({...default_options, series: all_data_series["Central"], subtitle: {text: "Central Region"}});
	    setOptions4({...default_options, series: all_data_series["Northeast"], subtitle: {text: "Northeast Region"}});
	    setOptions5({...default_options, series: all_data_series["Southeast"], subtitle: {text: "Southeast Region"}});
	    setOptions6({...default_options, series: all_data_series["Cape Cod"], subtitle: {text: "Cape Cod"}});
	    setOptions7({...default_options, series: all_data_series["Islands"], subtitle: {text: "Islands"}});
	  };

    const fetchData = () => {
      axios.get(dataFileName)
        .then(results => {
            fill_graph(results.data);
        })
        .catch(err => {
            console.log(err.message);
        });
    };

    useEffect(() => {
      setOptions1({...options1, series: null});
      fetchData();
      // eslint-disable-next-line
    }, []);

    return (
      <>
        <RegionHeader
          title={"Time Series of Index Severity Levels"}
          buttontext={"Table View"}
          buttonValue={buttonValue}
          handleButtonClick={handleButtonClick}
          addtext={""}
        />
        {options1.series ?
          <Grid container spacing={1}>
            <Grid key={0} size={{ xs: 12, sm: 6 }}>
              <HighchartsReact
                  highcharts={Highcharts}
                  options={options1}
              />
            </Grid>
            <Grid key={1} size={{ xs: 12, sm: 6 }}>
              <HighchartsReact
                highcharts={Highcharts}
                options={options2}
              />
            </Grid>
            <Grid key={2} size={{ xs: 12, sm: 6 }}>
              <HighchartsReact
                  highcharts={Highcharts}
                  options={options3}
                />
            </Grid>
            <Grid key={3} size={{ xs: 12, sm: 6 }}>
              <HighchartsReact
                  highcharts={Highcharts}
                  options={options4}
                />
            </Grid>
            <Grid key={4} size={{ xs: 12, sm: 6 }}>
              <HighchartsReact
                  highcharts={Highcharts}
                  options={options5}
                />
            </Grid>
            <Grid key={5} size={{ xs: 12, sm: 6 }}>
              <HighchartsReact
                  highcharts={Highcharts}
                  options={options6}
                />
            </Grid>
            <Grid key={6} size={{ xs: 12, sm: 6 }}>
              <HighchartsReact
                  highcharts={Highcharts}
                  options={options7}
                />
            </Grid>
            <Grid key={7} size={{ xs: 12, sm: 6 }} sx={{ fontSize:"80%", display: 'flex', justifyContent: "center", alignItems: 'center' }} >
              <ISLTable />
            </Grid>
          </Grid>
        :
          <>
            <CircularProgress />
            <span>Loading ...</span>
          </>
        }
      </>
  )
}

export default TimeSeriesGrf;
